import {
  BusinessDayPeriodInterface,
  GetDeviceProductionPlanDetailResponse,
  MarketPeriodInterface,
  ProductionPlanBaseProps
} from 'features/dispatcher/dispatcherTypes';
import { DeviceInterface } from 'features/eai/eaiTypes';
import { findDeviceProductionPlan } from 'views/modules/Dispatcher/dispatcherUtils/dispatcherUtils';
import { ReactElement } from 'react';
import { I18N_HX_PLANNING_CONTENT_DEVICE_ROOT } from 'views/modules/Dispatcher/HxDashboard/HxPlanning/HxPlanningContent/HxPlanningContentDevice/hxPlanningContentDeviceUtils';

// ==============================|| H+X PLANNING CONTENT DEVICE HEADER UTILS ||============================== //

export enum HxPlanningContentDeviceHeaderAction {
  DIRECT_CONFIRMATION = 'directConfirmation',
  PROPAGATION = 'propagation',
  DIRECT_PROPAGATION = 'directPropagation',
  SET_PREDICTION_TO_PRODUCTION = 'setPredictionToProduction'
}

export interface HxPlanningDeviceHeaderAction {
  action: HxPlanningContentDeviceHeaderAction;
  icon: ReactElement;
  variant?: 'text' | 'outlined' | 'contained';
}

export const getProductionByPeriod = (
  periods: BusinessDayPeriodInterface[],
  timeUnitNumber: number
) => {
  return periods
    ?.find(({ periodNumber }) => timeUnitNumber === periodNumber)
    ?.production?.toString();
};

export const hasProductionChanged = (
  timeUnitNumber: number,
  initialProductionPlanPeriods: BusinessDayPeriodInterface[],
  productionPlanRevisionPeriods: BusinessDayPeriodInterface[]
) => {
  const initialPeriodProduction = getProductionByPeriod(
    initialProductionPlanPeriods,
    timeUnitNumber
  );
  const newPeriodProduction = getProductionByPeriod(
    productionPlanRevisionPeriods,
    timeUnitNumber
  );

  return initialPeriodProduction !== newPeriodProduction;
};

export const hasProductionListChanged = (
  periods: MarketPeriodInterface[],
  initialProductionPlanPeriods: BusinessDayPeriodInterface[],
  productionPlanRevisionPeriods: BusinessDayPeriodInterface[]
) => {
  return periods.some((period) =>
    hasProductionChanged(
      period.timeUnitNumber,
      initialProductionPlanPeriods,
      productionPlanRevisionPeriods
    )
  );
};

export const getPropagationRequestProps = (
  productionPlanList: GetDeviceProductionPlanDetailResponse[],
  device: DeviceInterface,
  marketDay: string | null
) => {
  const deviceProductionPlan = findDeviceProductionPlan(
    productionPlanList,
    device.id
  );

  if (!deviceProductionPlan || !marketDay) return;

  const requestProps: ProductionPlanBaseProps = {
    selectedBusinessDay: marketDay,
    deviceId: device.id,
    etag: deviceProductionPlan.meta.etag,
    isProductionPlansForPlanning: true,
    productionPlanId: deviceProductionPlan.id
  };

  return requestProps;
};

export const fillEmptyProduction = (periods: BusinessDayPeriodInterface[]) => {
  return periods.map((period) => ({
    ...period,
    production: period.production ?? 0
  }));
};

export const getTooltipTitle = (action: HxPlanningContentDeviceHeaderAction) =>
  `${I18N_HX_PLANNING_CONTENT_DEVICE_ROOT}.actions.${action}`;
